export default {
    titles: {
        main_location_schedule: '{name} Schedule',
        modify_availability: 'Modify basic availability',
    },

    breadcrumbs: {
        availibility: 'Availability',
        main_location: 'Main location',
        schedule: 'Schedule',
    },

    buttons: {
        back_calendar: 'Back to Calendar',
        modify_availability: 'MODIFY BASIC AVAILABILITY',
    },
    labels: {
        main_location: 'Main location',
        appointment_length: 'Appointment length: {length} min',
    },
    modal: {
        appointment_details: 'Appointment Details',
        contact_information: 'Contact Information',
        medical_information: 'Medical Information',
        insurance_provider: 'Insurance Provider',
        reason_for_visit: 'Reason for Visit',
        last_visit: 'Last Visit',
        appointment_type: 'Appointment Type',
        appointment_date: 'Date',
        appointment_time: 'Time',
        age: 'Age',
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        status: 'Status',
        close: 'Close',
        edit_appointment: 'Edit Appointment',
        fallbacks: {
            not_available: 'Not available',
            unknown_age: 'Age not available',
            unknown_patient: 'Patient',
        },
    },
    statuses: {
        completed: 'Completed',
        confirmed: 'Confirmed',
        pending: 'Pending',
        cancelled: 'Cancelled/No Show',
    },
    actions: {
        set_available: 'Set Available',
        set_unavailable: 'Set Unavailable',
        create_referral: 'Create Referral',
        loading: 'Updating slot…',
        error: 'Unable to update slot. Please try again.',
        success: {
            available: 'Slot marked available',
            unavailable: 'Slot marked unavailable',
            updated: 'Slot updated',
        },
    },
    availability: {
        number_of_unset_locations: '{numberOfLocations} location{multiple} has no availability',
        set_availability: 'If you want to set availability for <b>{locationName}</b> click ',
    },
    no_locations_message: 'None of your locations match referral criteria. Please add tests to your location.',
    availability_saved: 'Availability Modified',
    calendar: {
        available: 'Available',
        not_available: 'Not Available',
        blocked: 'Blocked',
        no_am_slots: 'No AM slots',
        no_pm_slots: 'No PM slots',
        confirmed_count: '{count} confirmed',
        pending_count: '{count} pending',
        no_slots_for_day: 'No slots available for this day.',
    },
}
